import { Exclude, Expose, plainToInstance } from 'class-transformer';
import { IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import { ProjetoTipo } from '../projeto/projeto-tipo.enum';
import { RegistrationDto } from './registration.dto';

export class CreateRegistrationDto {
  id?: string;

  @Expose()
  @IsNumber()
  @IsNotEmpty()
  blockId: number;

  @Expose()
  @IsNumber()
  @IsNotEmpty()
  lotId: number;

  @Expose()
  @IsString()
  @IsOptional()
  leadId?: string;

  projetoFid?: string;

  @Exclude()
  projetoId?: number;

  propertyId?: string;

  @Exclude()
  usuarioIdResponsavel: number;

  @Exclude()
  usuarioFidResponsavel: string;

  @Exclude()
  usuarioIdInicioContrato: number;

  @Exclude()
  usuarioFidInicioContrato: string;

  @Exclude()
  projetoTipo: ProjetoTipo;

  /**
   * Cria uma nova instância de CreateRegistrationDto a partir de dtos
   * @param props DTO de Cadastro
   * @returns nova instância de CreateRegistrationDto
   */
  static from(props?: RegistrationDto | Partial<RegistrationDto>): CreateRegistrationDto {
    return plainToInstance(CreateRegistrationDto, props, { exposeUnsetFields: false, excludeExtraneousValues: true });
  }
}
